var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowtraceLogoOnly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter2952",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.21 -0.72 -0.07 2 0 "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2956",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.21 -0.72 -0.07 2 0 "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2960",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.21 -0.72 -0.07 2 0 "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2964",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.21 -0.72 -0.07 2 0 "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5002 0 0 2.4005 -40.777 -18.805)",
    fill: "none",
    stroke: "#174366"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.28089 0 0 .28089 11.888 2.2646)",
    d: "m46.876 140.81c10.5 9.835 24.615 15.857 40.136 15.857 14.71-4.4e-4 28.156-5.4094 38.459-14.347m18.637-30.601c1.062-4.4182 1.6246-9.0309 1.6246-13.775 8e-5 -26.308-17.3-48.575-41.144-56.046m-34.864-0.09033c-23.998 7.3811-41.435 29.725-41.435 56.137-1.3e-5 4.3258 0.46772 8.5424 1.3554 12.602",
    filter: "url(#filter2952)",
    strokeWidth: 7.2572
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.7483
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0616 0 0 1.0616 -2.1297 -1.0442)",
    d: "m54.14 36.82a4.6249 4.6249 0 0 1-4.6249 4.6249 4.6249 4.6249 0 0 1-4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249 4.6249",
    filter: "url(#filter2956)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0616 0 0 1.0616 -2.1297 -1.0442)",
    d: "m27.561 36.82a4.6249 4.6249 0 0 1-4.6249 4.6249 4.6249 4.6249 0 0 1-4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249 4.6249",
    filter: "url(#filter2960)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0616 0 0 1.0616 -2.1297 -1.0442)",
    d: "m40.851 13.907a4.6249 4.6249 0 0 1-4.6249 4.6249 4.6249 4.6249 0 0 1-4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249-4.6249 4.6249 4.6249 0 0 1 4.6249 4.6249",
    filter: "url(#filter2964)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowtraceLogoOnly);
export default __webpack_public_path__ + "static/media/flowtrace_logo_only.c7ca5f9eae8230af0998497da9d378c7.svg";
export { ForwardRef as ReactComponent };